import api from '../api/table-api';
export default {
  getTableList (url, param) {
    return new Promise((resolve, reject) => {
      api.getTableList(url, param).then(({ data }) => {
          if (data.code === 200) {
              resolve(data.result || []);
          } else {
              reject(data);
          }
      });
  });
  }
}